import Button from '../ButtonGroup/Button';
import Alma from '../icons/Alma';
import Close from '../icons/Close';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';

import { languageContent } from '../../@helpers';
import './style.scss';

@inject("ChatBotStore")
@observer

class ChatbotPopup extends Component {

  componentDidMount() {
    const { ChatBotStore: { initChatbotModal } } = this.props
    initChatbotModal()
  }

  render() {
    const { ChatBotStore: { showChatbotModal, closeChatbotModal } } = this.props;

    const content = languageContent();
    const { component } = content;

    const { pTagFirst, pTagSecond, pTagThird, pTagFourth, button } = component.ChatbotPopup;
    return (
      <dialog className="chatbot_popup" data-active={showChatbotModal}>
        <figure className="promo_panel-primary" data-colorscheme="broc" >
          <button className="button-icon" data-action="close" onClick={closeChatbotModal}><Close /></button>
          <span className="image_container"><Alma /></span>
          <figcaption>
            <strong>{pTagFirst}</strong> {pTagSecond} <strong> {pTagThird}</strong> {pTagFourth}
            <Button
              variant="chatbot:modal"
              destination="chatbot"
              copy={button.copy}
              label={button.label}
            />
          </figcaption>
        </figure>
      </dialog>
    )
  }
}

export default ChatbotPopup